import { Route, Switch } from "react-router-dom";
import Error404 from "components/routes/NotFound";
import { companiesPath, AsyncCompaniesPage, getLinkToCompaniesPage } from "./Companies";
import AsyncLeadsPage from "./Leads";
import Lists from "./Lists";
import ImportsPage from "./Imports";
import { paths } from "./const";
import { ContentHeader } from "feature/mainLayout/component/ContentHeader/ContentHeader";

const CrmPage = () => {
  return (
    <>
      <ContentHeader>
        <ContentHeader.Tabs.Navigation
          tabs={[
            {
              label: "Contacts",
              path: paths.contacts,
            },
            {
              label: "Accounts",
              path: getLinkToCompaniesPage(),
            },
            {
              label: "Lists",
              path: paths.lists,
            },
            {
              label: "Imports",
              path: paths.imports,
            },
          ]}
        />
      </ContentHeader>

      <Switch>
        <Route path={`${paths.contacts}/:leadUuid?`}>
          <AsyncLeadsPage />
        </Route>
        <Route path={companiesPath}>
          <AsyncCompaniesPage />
        </Route>
        <Route
          exact
          path={paths.lists}
        >
          <Lists />
        </Route>
        <Route
          exact
          path={paths.imports}
        >
          <ImportsPage />
        </Route>
        <Route>
          <Error404 />
        </Route>
      </Switch>
    </>
  );
};

export default CrmPage;
